
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/inventory/rexroth",
      function () {
        return require("private-next-pages/en/inventory/rexroth.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/inventory/rexroth"])
      });
    }
  